<template>
  <section class="case-creation">
    <div
      class="case-creation__step case-creation__cpt-information"
      v-if="!isBillingUser"
      v-loading="loading"
    >
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-billing-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">CPT Codes</h3>
          </div>
        </div>
        <div class="case-creation__cpt-information__body">
          <div class="case-creation__tabs cpt-information-tabs view">
            <el-table :data="addCPT" :row-class-name="conditionalRowClassName">
              <el-table-column label="CPT Code" prop="cpt_code">
                <template #default="scope">
                  <span>{{ scope.row.cpt_code }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Test Name"
                width="200"
                prop="test_name"
                v-if="hasBloodPanel"
              >
                <template #default="scope">
                  <span>{{
                    scope.row.test_name ? scope.row.test_name : "--"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="M1" prop="m1">
                <template #default="scope">
                  <span>{{ scope.row.m1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="M2" prop="m2">
                <template #default="scope">
                  <span>{{ scope.row.m2 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="M3" prop="m3">
                <template #default="scope">
                  <span>{{ scope.row.m3 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="M4" prop="m4">
                <template #default="scope">
                  <span>{{ scope.row.m4 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="ICD-1" prop="icd_1">
                <template #default="scope">
                  <span>{{ scope.row.icd_1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="ICD-2" prop="icd_2">
                <template #default="scope">
                  <span>{{ scope.row.icd_2 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="ICD-3" prop="icd_3">
                <template #default="scope">
                  <span>{{ scope.row.icd_3 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="ICD-4" prop="icd_4">
                <template #default="scope">
                  <span>{{ scope.row.icd_4 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Unit" prop="unit">
                <template #default="scope">
                  <span>{{ scope.row.unit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Charge" prop="charge">
                <template #default="scope">
                  <span>{{ scope.row.charge }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Total" prop="total">
                <template #default="scope">
                  <span>{{ Math.round(scope.row.total) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Remarks" width="140" prop="remarks">
                <template #default="scope">
                  <el-button
                    placement="top"
                    class="title-on-hover"
                    :title="scope.row.remarks"
                    @click="scope.row.remarks"
                  >
                    <span class="remark-value">{{ scope.row.remarks }}</span>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-cpt-btn">
              <div class="total-sum-count pr-10" v-if="totalUnitsSum">
                <p class="total-sum">
                  Total Sum :
                  <span class="count">
                    (
                    {{ Math.round(totalUnitsSum) }}
                    )
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      addCPT: [
        {
          cpt_code: "",
          test_name: "",
          m1: "",
          m2: "",
          m3: "",
          m4: "",
          icd_1: "",
          icd_2: "",
          icd_3: "",
          icd_4: "",
          unit: 1,
          charge: "",
          total: "",
          remarks: "",
          cptCodeError: false,
          unitError: false,
          chargeError: false,
          icdError: false,
          is_covered: false, 
        },
      ],
      totalUnitsSum: "",
    };
  },
  computed: {
    ...mapGetters("cases", [
      "getCPTForAccession",
      "getCaseInformation",
    ]),
    hasBloodPanel() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    conditionalRowClassName() {
    return this.hasBloodPanel ? this.cptRowClass : () => '';
  }
  },
  async mounted() {
    if (this.$route.params.case_id) {
      await this.fetchCPTCode();
    }
  },
  methods: {
    cptRowClass({ row }) {
      return row.is_covered === false ? 'row-not-covered' : '';
    },
    async fetchCPTCode() {
      try {
        if (
          this.getCaseInformation &&
          this.getCaseInformation?.cpt_coding_charges_final_sum
        ) {
          this.totalUnitsSum =
            this.getCaseInformation.cpt_coding_charges_final_sum;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.cpt_coding_details.length != 0
        ) {
          this.addCPT = this.getCaseInformation.cpt_coding_details.map(
            (item) => ({
              cpt_code: item.cpt_code,
              test_name: item.test_name || "",
              m1: item.m1,
              m2: item.m2,
              m3: item.m3,
              m4: item.m4,
              icd_1: item.icd_1,
              icd_2: item.icd_2,
              icd_3: item.icd_3,
              icd_4: item.icd_4,
              unit: item.unit,
              charge: item.charge,
              total: item.total,
              remarks: item.remarks,
              is_covered: item.is_covered 
            })
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
.el-table__row.row-not-covered > td {
  background-color: rgb(245, 145, 145) !important;
}
</style>
